import { useEffect } from "react";

const useResize = (onResizeFn: () => void): void => {
  useEffect(() => {
    onResizeFn();
    window.addEventListener("resize", onResizeFn);
    return (): void => {
      window.removeEventListener("resize", onResizeFn);
    };
  }, [onResizeFn]);
};

export default useResize;
